import React, { Component } from 'react'
import { observable, makeObservable } from 'mobx'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'

import Button from '../../UniformComponents/Button'
import CKeditor5 from '../CKeditor5'
import PanelAccordion from '../PanelAccordion'
import { trackBuilderPageMenuAction } from '../../utils/MixpanelManager'

@observer
export default class CompletionPage extends Component {
    @observable show = true

    @observable saveState = ''

    constructor(props) {
        super(props)
        makeObservable(this)
    }

    toggleShow = () => {
        this.show = !this.show
    }

    savePage = () => {
        const that = this
        const { page, store } = this.props
        const { survey } = store
        if (store.survey.closed) {
            return
        }
        const langCode = store.surveyLocale

        const content = {
            locale: langCode,
            text: page.content.get(langCode).text,
            redirectUrlSettings: page.redirectUrlSettings,
        }

        const redirectUrl = R.pathOr(null, ['redirectUrlSettings', 'redirectUrl'], page)

        if (!R.isNil(redirectUrl) && !R.isEmpty(redirectUrl)) {
            if (!page.redirectUrlSettings.redirectUrl.match(/http[s]?:\/\//)) {
                store.addNotification(null, 'Invalid redirect URL. Missing http:// or https://', 'error')
                that.saveState = 'failed'
                return
            }
        }

        store.http.put(`/api/survey/${survey.id}/page/${page.id}/content`, JSON.stringify(content), store.surveyToken)
            .then((response) => {
                const state = response.match(/updated/) ? 'saved' : 'failed'
                if (state === 'saved') {
                    store.addNotification(null, 'Completion page saved', 'success')
                } else {
                    store.addNotification(null, 'Error saving completion page', 'error')
                }
                that.saveState = state
            })
            .catch((e) => {
                store.addNotification(null, e.message, 'error')
                that.saveState = 'failed'
            })
    }

    handleEditorChange = (value) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        const langCode = store.surveyLocale

        page.content.get(langCode).text = value
    }

    updateTitle = (e) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        page.title = e.target.value
        page.update()
    }

    removeRedirect = () => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        page.redirectUrlSettings = {}
        trackBuilderPageMenuAction(store, { action: 'remove redirect url' })
        this.savePage()
    }

    updateRedirectUrl = (e) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }
        trackBuilderPageMenuAction(store, { action: 'update redirect url' })
        page.redirectUrlSettings.redirectUrl = e.value.trim()
    }

    updateDelayMs = (e) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }
        trackBuilderPageMenuAction(store, { action: 'update redirect delay', value: parseInt(e.value, 10) })
        page.redirectUrlSettings.delayRedirectSec = parseInt(e.value, 10)
    }

    getContent = () => {
        const { page, store } = this.props
        const { survey } = store
        const langCode = store.surveyLocale

        if (!page.content.has(langCode)) {
            const text = page.content.has(survey.metadata.defaultLocale) ? page.content.get(survey.metadata.defaultLocale).text : ''
            page.content.set(langCode, {
                text,
            })
        }

        return page.content.get(langCode).text
    }

    previewPage = () => {
        const { page, store } = this.props
        trackBuilderPageMenuAction(store, { action: 'preview page' })

        let link = store.survey.getPreviewLink(true, store.useLatestUI, store.surveyLocale)

        link += `&pageId=${page.id}`

        store.gotoExternal(link)
    }

    removePage = (e) => {
        const { page, store } = this.props

        if (store.survey.closed) {
            return
        }

        store.pageToDeleteId = page.id
        store.pageToDeleteType = 'CO'
        store.pageDeleteConfirm = true
        e.preventDefault()
    }

    dataViewerLink = () => {
        const { page } = this.props
        return (
            <a className="redlink" target='_blank' href={'/intranet/dataviewer?schema=explori_v3&tablename=survey_page_question&f1=surveyPageId&op1=eq&val1='+ page.id + '&viewdata=true'}>
                {page.id}
            </a>
        )
    }

    render() {
        const { page_id, page, store, isFirstExitPage } = this.props
        const { survey, userData } = store
        const canEdit = userData.role <= 140
        const key = page_id + "tinymce"
        const content = this.getContent()

        return (
            <PanelAccordion
                title={`${i18n.t('s_page')} ${page.priority}`}
                subtitle={page.title}
                show={this.show}
                toggle={this.toggleShow}
                options="exit"
                updateURL={this.updateRedirectUrl}
                updateDelay={this.updateDelayMs}
                preview={this.previewPage}
                save={this.savePage}
                page={page}
                canEdit={canEdit}
                setPageLabel={({ value }) => store.setPageLabel(page, value)}
                remove={this.removePage}
                removeRedirect={this.removeRedirect}
                disabled={survey.closed}
                isFirstExitPage={isFirstExitPage}
            >
                <div className="editor-wrapper page-accordion-content">
                    {store.showIds
                        && <span style={{ marginLeft: '5px' }}>{this.dataViewerLink()}</span>}

                    <CKeditor5
                        activeClass="p10"
                        toolbar="surveyExit"
                        key={key}
                        store={store}
                        data={content}
                        onBlur={this.handleEditorChange}
                        config={{
                            mergeFields: store.mergeFields,
                        }}
                    />

                    <br />

                    <Button
                        cssClass="primary regular pull-right"
                        onClick={this.savePage}
                        disabled={survey.closed}
                    >
                        {i18n.t('save')}
                    </Button>
                </div>
            </PanelAccordion>
        )
    }
}
